import React from "react";
import PropTypes from "prop-types";
import Modal from "../../Modal";
import Button from "wonderbly-components/lib/Button";
import CloseIcon from "wonderbly-components/lib/CloseIcon";
import { useGlobalContent } from "../../../hooks";

import "./LineItemModal.scss";

const LineItemModal = (props) => {
  const { checkout } = useGlobalContent();

  return (
    <Modal default isOpen={props.isOpen} className="LineItemModal">
      <div
        className="LineItemModal__wrap"
        style={{ backgroundColor: props.backgroundColor }}
      >
        <div className="LineItemModal__header">
          <CloseIcon onHandleClick={props.handleClose} color="#00294C" />
        </div>
        <div className="LineItemModal__image-wrap">
          <img
            className="LineItemModal__image"
            src={`${props.image.url}${
              props.image.isMuseImage ? "&_width=958" : ""
            }`}
            alt={props.image.alt || ""}
          />
        </div>
      </div>
      <div className="LineItemModal__inner">
        {props.title && <h4 className="LineItemModal__title">{props.title}</h4>}
        {props.edit?.isEditable &&
          checkout.lineItemImage &&
          checkout.lineItemImage.ctaEdit && (
            <Button
              className="LineItemModal__cta"
              href={props.edit.editUrl}
              onClick={props.edit.handleEdit}
              fullWidth
            >
              {checkout.lineItemImage.ctaEdit}
            </Button>
          )}
        {checkout.lineItemImage.ctaClose && (
          <Button
            className="LineItemModal__cta"
            onClick={props.handleClose}
            fullWidth
          >
            {checkout.lineItemImage.ctaClose}
          </Button>
        )}
      </div>
    </Modal>
  );
};

LineItemModal.defaultProps = {
  backgroundColor: "#f5f5f0",
};

LineItemModal.propTypes = {
  handleClose: PropTypes.func.isRequied,
  isOpen: PropTypes.bool.isRequied,
  title: PropTypes.string,
  image: PropTypes.shape({
    isMuseImage: PropTypes.bool,
    url: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }).isRequied,
  backgroundColor: PropTypes.string,
  edit: PropTypes.shape({
    editUrl: PropTypes.object,
    handleEdit: PropTypes.func,
    isEditable: PropTypes.bool,
  }),
};

export default LineItemModal;
